/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
import MoserObjectUtils from './MoserObjectUtils';
import SortOrder from './SortOrder';
import SortOrderNullPlacement from './SortOrderNullPlacement';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // propertyOverrideForFacetType
//@import com/ibm/bi/platform/moser/common/generated/metadata/SortOrder (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SortOrderNullPlacement (runtime) // new

/**
 * <p>Java class for sortListType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="sortListType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="sortItem" maxOccurs="unbounded"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="order" type="{}sortOrder"/&gt; &lt;element name="nullPlacement" type="{}sortOrderNullPlacement"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class SortListType extends MoserObject{

	sortItem = null;



	/**
	 * Gets the value of the sortItem property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the sortItem property. <p> For example, to add a new item, do as follows: <pre> getSortItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link SortListType.SortItem}
	 */
	getSortItem() {
		if (!this.sortItem) {
			this.sortItem = [];
		}
		return this.sortItem;
	}

	/**
	 * Gets the value of the <code>sortItem</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>SortItem</code> elements, or <code>null</code> if not set
	 */
	basicGetSortItem() {
		return this.sortItem;
	}

	/**
	 * Creates a new instance of <code>SortListType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> SortListType</code> object from.
	 * @return {SortListType} an object of type <code>SortListType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createSortListType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addSortItemAt(position, item) {
		this._addAtAndNotify(this.getSortItem(), position, item, 183, true, false);
		MoserObjectUtils.propertyOverrideForFacetType(this);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addSortItem(item) {
		this.addSortItemAt(this.getSortItem().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeSortItemAt(position) {
		this._removeAtAndNotify(this.getSortItem(), position, 183, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeSortItem(item) {
		var i = this.getSortItem().indexOf(item);
		if (i >= 0) {
			this.removeSortItemAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "SortListType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		var clazz;
		if (factory) {
			clazz = factory.createSortListTypeSortItem().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 183, "sortItem", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 183:
			this.sortItem = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 183:
			return this.getSortItem();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 183:
			return this.basicGetSortItem();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 183:
			this.addSortItemAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 183:
			this.addSortItem((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 183:
			this.removeSortItemAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 183:
			this.removeSortItem((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="order" type="{}sortOrder"/&gt; &lt;element name="nullPlacement" type="{}sortOrderNullPlacement"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
SortListType.SortItem = class extends MoserObject{

	ref = null;

	order = null;

	nullPlacement = null;

	_referencedObject = null;



	/**
	 * Gets the value of the ref property.
	 * @return {String} possible object is {@link String}
	 */
	getRef() {
		return this.ref;
	}

	/**
	 * Sets the value of the ref property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRef(value) {
		var oldValue = this.ref;
		this.ref = value;
		this._setAndNotify(36, oldValue, value, false, false);
		MoserObjectUtils.propertyOverrideForFacetType(this);
		this._referencedObject = null;
	}

	/**
	 * Gets the value of the order property.
	 * @return {SortOrder} possible object is {@link SortOrder}
	 */
	getOrder() {
		return this.order;
	}

	/**
	 * Sets the value of the order property.
	 * @param {SortOrder} value allowed object is {@link SortOrder}
	 */
	setOrder(value) {
		var oldValue = this.order;
		this.order = value;
		this._setAndNotify(41, oldValue, value, false, false);
		MoserObjectUtils.propertyOverrideForFacetType(this);
	}

	/**
	 * Gets the value of the nullPlacement property.
	 * @return {SortOrderNullPlacement} possible object is {@link SortOrderNullPlacement}
	 */
	getNullPlacement() {
		return this.nullPlacement;
	}

	/**
	 * Sets the value of the nullPlacement property.
	 * @param {SortOrderNullPlacement} value allowed object is {@link SortOrderNullPlacement}
	 */
	setNullPlacement(value) {
		var oldValue = this.nullPlacement;
		this.nullPlacement = value;
		this._setAndNotify(40, oldValue, value, false, false);
		MoserObjectUtils.propertyOverrideForFacetType(this);
	}

	/**
	 * Creates a new instance of <code>SortItem</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> SortItem</code> object from.
	 * @return {SortItem} an object of type <code>SortItem</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createSortListTypeSortItem();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "SortItem";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 36, "ref", null));
		featureList.push(this.createFeature(false, true, false, 41, "order", SortOrder));
		featureList.push(this.createFeature(false, true, false, 40, "nullPlacement", SortOrderNullPlacement));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 36:
			this.setRef((value));
			break;
		case 40:
			this.setNullPlacement((value));
			break;
		case 41:
			this.setOrder((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 36:
			return this.getRef();
		case 40:
			return this.getNullPlacement();
		case 41:
			return this.getOrder();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 36:
			return this.getRef();
		case 40:
			return this.getNullPlacement();
		case 41:
			return this.getOrder();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the resolved object based on reference.
	 * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	 */
	setReferencedObject(referencedObject) {
		this._referencedObject = referencedObject;
	}

	/**
	 * Get the resolved object based on reference.
	 * @return {MoserObject} the referenced <code>MoserObject</code>
	 */
	getReferencedObject() {
		return this._referencedObject;
	}

	clone() {
		var cloned = (super.clone());
		cloned.setReferencedObject(this._referencedObject);
		return cloned;
	}
}


// WEBPACK FOOTER //
// ./src/generated/SortListType.js